<!-- TODO: refactor this comp to itierate on LOV data -->
<div class="row" [ngClass]="{'invalid-input': invalidInput }">
  <div class="col">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="tourPackage" (change)="onCheckboxChange($event, TRAVEL_SERVICES.TOUR_PACKAGE)" [checked]="isChecked(TRAVEL_SERVICES.TOUR_PACKAGE)">
      <label for="tourPackage" class="checkbox-label">Tour Package</label>
    </div>
  </div>

  <div class="col">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="hotels" (change)="onCheckboxChange($event, TRAVEL_SERVICES.HOTELS)" [checked]="isChecked(TRAVEL_SERVICES.HOTELS)">
      <label for="hotels" class="checkbox-label">Hotels</label>
    </div>
  </div>

  <div class="col">
    <div class="input-item">
      <input type="checkbox" [disabled]="disableServiceType" id="sightseeing" (change)="onCheckboxChange($event, TRAVEL_SERVICES.SIGHTSEEING)" [checked]="isChecked(TRAVEL_SERVICES.SIGHTSEEING)">
      <label for="sightseeing" class="checkbox-label">Sightseeing</label>
    </div>
  </div>
</div>
